<div class="wrapper relative">
  <div class="spin" *ngIf="isLoading">
    <ng-lottie [options]="options" width="280px"></ng-lottie>
  </div>

  <map-coordinates-finder
    *ngIf="isCoordinatesPopupVisible"
    (onClose)="isCoordinatesPopupVisible = false"
    [map]="map"
  ></map-coordinates-finder>
  <div id="ol-map" class="ol-map"></div>
  <div #olPopup class="ol-popup" [ngClass]="{ 'is-open': isPopupVisible }">
    <a href="#" class="ol-popup-closer"></a>
    <div class="ol-popup-content">
      <div>
        <span translationEditableDirective="NAME"
          >{{ 'NAME' | translate }}:</span
        >
        {{ popupData.label || '-' }}
      </div>
      <div>
        <span translationEditableDirective="TOTAL"
          >{{ 'TOTAL' | translate }}:</span
        >
        {{ (popupData.total | number) || '-' }}
      </div>
      <div>
        <span translationEditableDirective="PROCESSED"
          >{{ 'PROCESSED' | translate }}:</span
        >
        {{ (popupData.processed | number) || '-' }}
      </div>
      <div>
        <span translationEditableDirective="PERCENTAGE"
          >{{ 'PERCENTAGE' | translate }}:</span
        >
        {{ (popupData.percentage | number) || '-' }}
      </div>
    </div>
  </div>
  <div style="display: flex; align-items: center" class="mt-3">
    <span class="mx-1">0%</span>
    <span
      [ngStyle]="{
        background: color,
        display: 'block',
        width: '20px',
        height: '20px'
      }"
      *ngFor="let color of gradientColors"
    ></span>
    <span class="mx-1">100%</span>
  </div>
</div>
